import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api/client';
import Button from '../components/Button';
import FormField, { Input } from '../components/FormField';

export default function Register() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: '', username: '', password: '', firstname: '', lastname: '', nickname: '', discord_name: '' });
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState('');
  const [loading, setLoading] = useState(false);
  const set = (f) => (e) => setForm({ ...form, [f]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors({}); setApiError(''); setLoading(true);
    try {
      await api.post('/api/auth/register', form);
      navigate('/login?registered=1');
    } catch (err) {
      const detail = err.response?.data?.detail;
      if (Array.isArray(detail)) {
        const errs = {};
        detail.forEach((d) => { const f = d.loc?.[1]; if (f) errs[f] = d.msg; });
        setErrors(errs);
      } else {
        setApiError(detail || 'Registrierung fehlgeschlagen');
      }
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-xl mx-auto mt-4 sm:mt-8">
      <div className="text-center mb-8">
        <div className="text-4xl mb-2">🏖️</div>
        <h1 className="text-2xl font-bold text-ocean-900">Konto erstellen</h1>
        <p className="text-slate-500 mt-1 text-sm">Sei dabei beim nächsten BeachLAN Event</p>
      </div>

      <div className="card">
        {apiError && <div className="alert-error mb-4">{apiError}</div>}
        <form onSubmit={handleSubmit}>
          <div className="grid grid-cols-2 gap-x-4">
            <FormField label="Vorname" required error={errors.firstname}>
              <Input value={form.firstname} onChange={set('firstname')} placeholder="Max" required />
            </FormField>
            <FormField label="Nachname" required error={errors.lastname}>
              <Input value={form.lastname} onChange={set('lastname')} placeholder="Mustermann" required />
            </FormField>
          </div>
          <FormField label="Benutzername" required error={errors.username}>
            <Input value={form.username} onChange={set('username')} placeholder="maxmustermann" required />
          </FormField>
          <FormField label="E-Mail" required error={errors.email}>
            <Input type="email" value={form.email} onChange={set('email')} placeholder="max@beispiel.de" required />
          </FormField>
          <FormField label="Passwort" required error={errors.password}>
            <Input type="password" value={form.password} onChange={set('password')} placeholder="••••••••" required />
            <p className="text-xs text-slate-400 mt-1">Min. 8 Zeichen, Groß-/Kleinbuchstaben und eine Zahl</p>
          </FormField>
          <div className="grid grid-cols-2 gap-x-4">
            <FormField label="Nickname (optional)" error={errors.nickname}>
              <Input value={form.nickname} onChange={set('nickname')} placeholder="GameKing42" />
            </FormField>
            <FormField label="Discord (optional)" error={errors.discord_name}>
              <Input value={form.discord_name} onChange={set('discord_name')} placeholder="username#1234" />
            </FormField>
          </div>
          <Button type="submit" loading={loading} className="w-full mt-2">Konto erstellen</Button>
        </form>
        <p className="text-center mt-4 text-sm text-slate-500">
          Bereits registriert?{' '}
          <Link to="/login" className="font-semibold text-ocean-600 hover:text-ocean-800 no-underline">Anmelden</Link>
        </p>
      </div>
    </div>
  );
}
